import { IconVideo } from '@/assets/images';
import { AppText } from '@/components';
import { handleSelectMedia } from '@/features/chats/sub-features/media/utils/mediaUtils';
import { getThumbBase64URL, millisToMinutesAndSeconds } from '@/shared/utils';
import PropTypes from 'prop-types';
import React from 'react';

function DisplayMessages({ messages, activeChatJid }) {
   const displayMessages = messages.slice(0, 4);
   const count = messages.length;
   const gridClass = `media-grid count-${Math.min(count, 4)}`;

   const renderMediaItem = (msg, index) => {
      const msgType = msg.msgBody?.message_type;
      const media = msg.msgBody?.media || {};
      const { thumb_image = '', blobUrl = '', duration = 0, is_downloaded, is_uploading } = media;
      const isLoaded = is_uploading === 2 && is_downloaded === 2;
      const thumbUrl = getThumbBase64URL(thumb_image);

      const src = msgType === 'video' ? thumbUrl : blobUrl || thumbUrl;

      const isLastSlot = index === 3 && count > 4;

      const handleMessageClick = () => {
         handleSelectMedia({ message: msg, activeChatJid, chatType: msg.chatType });
      };

      const className = `media-grid-item item-${index} ${isLastSlot ? 'has-overlay' : ''}`.trim();

      return (
         <button key={msg.msgId} className={className} onClick={handleMessageClick} disabled={!isLoaded}>
            <div className="media-content-wrap ct-relative ct-flexCenter">
               <img src={src} alt="" className="media-thumbnail" />

               {msgType === 'video' && (
                  <div className="video-duration ct-flex ct-aiCenter ct-gap4">
                     <i className="ct-icon ct-xs">
                        <IconVideo />
                     </i>
                     <p>{millisToMinutesAndSeconds(duration)}</p>
                  </div>
               )}

               {isLastSlot && (
                  <div className="media-overlay ct-flexCenter">
                     <AppText as="span">{`+${count - 3}`}</AppText>
                  </div>
               )}
            </div>
         </button>
      );
   };

   return <div className={gridClass}>{displayMessages.map((msg, idx) => renderMediaItem(msg, idx))}</div>;
}

DisplayMessages.propTypes = {
   messages: PropTypes.array.isRequired,
   activeChatJid: PropTypes.string,
};

export default React.memo(DisplayMessages);
